// HSL color type

export type HSLColor = {
  h: number // hue (0-360 degrees)
  s: number // saturation (0-1)
  l: number // lightness (0-1)
  a: number // alpha (0-1)
}
